// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileUpload {
   position: relative;
   overflow: hidden;
   margin: 10px;
}

.fileUpload input.upload {
   position: absolute;
   top: 0;
   right: 0;
   margin: 0;
   padding: 0;
   font-size: 20px;
   cursor: pointer;
   opacity: 0;
   filter: alpha(opacity=0);
}

.tab-container {
   padding-top: 10px;
   display: flex;
   padding-right: 24px;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.center {
   margin: auto;
   width: 60%;
   padding: 10px;
}

.doc-file {
   overflow: auto;
   width: 100%;
   height: calc(100vh - 300px);
}

@media (min-height: 768px) {

   .object-file {
      height: 50px;
   }

}

@media (min-height: 600px) and (max-height: 768px) {
   /*desktop small screen */

   .object-file {
      height: 50px;
   }
}

.document-upload {
   padding-top: 10px;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 100%;
   overflow: hidden;
}

.flex {
   display: flex;
}

.flex-container {
   display: flex;
   max-width: 100%;
}

.menu-input-task {
   width: 60%;
}

.menu-input-cert{
   width: 65%;
}

.link {
   border: 1px solid #00b2c9;
   color: #444;
   padding: 0.5em;
   white-space: nowrap;
   overflow: hidden !important;
   text-overflow: ellipsis;
   display: inline-block;
}

.export {
   border-radius: 0;
   box-shadow: none;
   min-width: inherit;
   padding: 0 12px;
}

.check-box {
   padding: 0 5px 0 0;
}

input, textarea {
   outline: none;
}

span {
   color: rgba(0,0,0,0.87);
}

.radio-button {
   margin-left: 6px;
}

.menu-export-task {
   margin: 15px 0 20px 20px;
   height:60px;
}
.desc {
   margin-top: -8px!important;
   padding-bottom: 6px;
   color: #999;
   font-size: 12px;
}
.name,.desc {
   word-wrap: break-word;
   position: relative;
   white-space: pre-line;
   overflow: hidden;
   text-overflow: ellipsis;
   line-height: 1.1;
}
.name{
   padding-top:10px;
}
.option{
   line-height: 1.2!important;
}
.div-form-name {
   line-height: 1.1;
}
.menu-end-date{
   margin: 10px 0 0 5px;
}
.menu-delete-date{
   height:20px;
}
.error-message{
   margin: -15px 0 10px 0;
   color:red;
}
.due-date{
   margin-top:-20px;
   width:22%;
}
.day-left{
   margin-top:-20px;
   width:13%;
}
.input-sign-date{
   margin: -15px 5px 15px 5px;
}
.form-date{
   margin-top:10px;
   height:45px;
}
.export-open{
   margin-top:25px!important;
}
.error-show{
   margin-top:10px;
}
.input-field{
   width:45%;
}

.formate-radio-group {
   display: flex;
   flex-direction: column;
   margin: 15px 0;
}

.required:after {
   content:" *";
   color: red;
}

::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {
   background-color: #ffc107!important;
}

::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
  border-color:#ffc107!important;
}

::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-ripple .mat-ripple-element {
    opacity: 0.03 !important;
    background-color: #ffc107!important;
}

::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background,.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {
    background-color: #ffc107;
}

.itemMenu-img {
   margin-right: 14px !important;
   object-fit: contain;
}

.contact-link {
   color: #36c6d3;
   cursor: pointer;
   font-size: 12px;
}

::ng-deep .dropdown-search{
   top: 0 ;
   padding: 0 15px 0 15px!important;
   width: 100%!important;
   background: white;
   height: 100% !important;
   overflow-y: auto!important;
   position : sticky!important;
   z-index: 1;
}

.select-list{
   width:35%!important;
   height:20%!important;
   margin: 5px 0 0 0!important;
   padding-left: 5px;
}
.disabled {
   color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/upload-document/upload-document.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,SAAS;GACT,UAAU;GACV,eAAe;GACf,eAAe;GACf,UAAU;GACV,wBAAwB;AAC3B;;AAEA;GACG,iBAAiB;GACjB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,YAAY;GACZ,UAAU;GACV,aAAa;AAChB;;AAEA;GACG,cAAc;GACd,WAAW;GACX,2BAA2B;AAC9B;;AAEA;;GAEG;MACG,YAAY;GACf;;AAEH;;AAEA;GACG,wBAAwB;;GAExB;MACG,YAAY;GACf;AACH;;AAEA;GACG,iBAAiB;GACjB,uBAAuB;GACvB,mBAAmB;GACnB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,yBAAyB;GACzB,WAAW;GACX,cAAc;GACd,mBAAmB;GACnB,2BAA2B;GAC3B,uBAAuB;GACvB,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,wBAAwB;GACxB,WAAW;AACd;AACA;GACG,0BAA0B;GAC1B,mBAAmB;GACnB,WAAW;GACX,eAAe;AAClB;AACA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,qBAAqB;GACrB,gBAAgB;GAChB,uBAAuB;GACvB,gBAAgB;AACnB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,0BAA0B;AAC7B;AACA;GACG,gBAAgB;AACnB;AACA;GACG,oBAAoB;AACvB;AACA;GACG,WAAW;AACd;AACA;GACG,sBAAsB;GACtB,SAAS;AACZ;AACA;GACG,gBAAgB;GAChB,SAAS;AACZ;AACA;GACG,gBAAgB;GAChB,SAAS;AACZ;AACA;GACG,0BAA0B;AAC7B;AACA;GACG,eAAe;GACf,WAAW;AACd;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,eAAe;AAClB;AACA;GACG,SAAS;AACZ;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,cAAc;AACjB;;AAEA;GACG,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,mCAAmC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;GACG,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,OAAO;GACP,gCAAgC;GAChC,qBAAqB;GACrB,iBAAiB;GACjB,uBAAuB;GACvB,0BAA0B;GAC1B,2BAA2B;GAC3B,UAAU;AACb;;AAEA;GACG,mBAAmB;GACnB,oBAAoB;GACpB,2BAA2B;GAC3B,iBAAiB;AACpB;AACA;GACG,WAAW;AACd","sourcesContent":[".fileUpload {\n   position: relative;\n   overflow: hidden;\n   margin: 10px;\n}\n\n.fileUpload input.upload {\n   position: absolute;\n   top: 0;\n   right: 0;\n   margin: 0;\n   padding: 0;\n   font-size: 20px;\n   cursor: pointer;\n   opacity: 0;\n   filter: alpha(opacity=0);\n}\n\n.tab-container {\n   padding-top: 10px;\n   display: flex;\n   padding-right: 24px;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.center {\n   margin: auto;\n   width: 60%;\n   padding: 10px;\n}\n\n.doc-file {\n   overflow: auto;\n   width: 100%;\n   height: calc(100vh - 300px);\n}\n\n@media (min-height: 768px) {\n\n   .object-file {\n      height: 50px;\n   }\n\n}\n\n@media (min-height: 600px) and (max-height: 768px) {\n   /*desktop small screen */\n\n   .object-file {\n      height: 50px;\n   }\n}\n\n.document-upload {\n   padding-top: 10px;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   max-width: 100%;\n   overflow: hidden;\n}\n\n.flex {\n   display: flex;\n}\n\n.flex-container {\n   display: flex;\n   max-width: 100%;\n}\n\n.menu-input-task {\n   width: 60%;\n}\n\n.menu-input-cert{\n   width: 65%;\n}\n\n.link {\n   border: 1px solid #00b2c9;\n   color: #444;\n   padding: 0.5em;\n   white-space: nowrap;\n   overflow: hidden !important;\n   text-overflow: ellipsis;\n   display: inline-block;\n}\n\n.export {\n   border-radius: 0;\n   box-shadow: none;\n   min-width: inherit;\n   padding: 0 12px;\n}\n\n.check-box {\n   padding: 0 5px 0 0;\n}\n\ninput, textarea {\n   outline: none;\n}\n\nspan {\n   color: rgba(0,0,0,0.87);\n}\n\n.radio-button {\n   margin-left: 6px;\n}\n\n.menu-export-task {\n   margin: 15px 0 20px 20px;\n   height:60px;\n}\n.desc {\n   margin-top: -8px!important;\n   padding-bottom: 6px;\n   color: #999;\n   font-size: 12px;\n}\n.name,.desc {\n   word-wrap: break-word;\n   position: relative;\n   white-space: pre-line;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   line-height: 1.1;\n}\n.name{\n   padding-top:10px;\n}\n.option{\n   line-height: 1.2!important;\n}\n.div-form-name {\n   line-height: 1.1;\n}\n.menu-end-date{\n   margin: 10px 0 0 5px;\n}\n.menu-delete-date{\n   height:20px;\n}\n.error-message{\n   margin: -15px 0 10px 0;\n   color:red;\n}\n.due-date{\n   margin-top:-20px;\n   width:22%;\n}\n.day-left{\n   margin-top:-20px;\n   width:13%;\n}\n.input-sign-date{\n   margin: -15px 5px 15px 5px;\n}\n.form-date{\n   margin-top:10px;\n   height:45px;\n}\n.export-open{\n   margin-top:25px!important;\n}\n.error-show{\n   margin-top:10px;\n}\n.input-field{\n   width:45%;\n}\n\n.formate-radio-group {\n   display: flex;\n   flex-direction: column;\n   margin: 15px 0;\n}\n\n.required:after {\n   content:\" *\";\n   color: red;\n}\n\n::ng-deep .mat-radio-button.mat-accent .mat-radio-inner-circle {\n   background-color: #ffc107!important;\n}\n\n::ng-deep.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {\n  border-color:#ffc107!important;\n}\n\n::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-ripple .mat-ripple-element {\n    opacity: 0.03 !important;\n    background-color: #ffc107!important;\n}\n\n::ng-deep.mat-checkbox-checked.mat-accent .mat-checkbox-background,.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {\n    background-color: #ffc107;\n}\n\n.itemMenu-img {\n   margin-right: 14px !important;\n   object-fit: contain;\n}\n\n.contact-link {\n   color: #36c6d3;\n   cursor: pointer;\n   font-size: 12px;\n}\n\n::ng-deep .dropdown-search{\n   top: 0 ;\n   padding: 0 15px 0 15px!important;\n   width: 100%!important;\n   background: white;\n   height: 100% !important;\n   overflow-y: auto!important;\n   position : sticky!important;\n   z-index: 1;\n}\n\n.select-list{\n   width:35%!important;\n   height:20%!important;\n   margin: 5px 0 0 0!important;\n   padding-left: 5px;\n}\n.disabled {\n   color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
